import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from 'utils/axios';
import { URLS } from 'constants/api.constants';
export const searchArticles = createAsyncThunk(
  'search/getArticles',
  async ({ search, page }, { rejectWithValue }) => {
    try {
      console.log(search);
      const response = await axiosInstance.get(
        `${URLS.SEARCH_ARTICLES.GET_SEARCH_ARTICLES}?search=${
          search || ''
        }&page=${page || 1}&limit=10`
      );
      if (response.data?.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error('Search Articles API Error:', error);
      return rejectWithValue(
        error?.message || 'An error occurred while fetching search articles'
      );
    }
  }
);
